import { OkthxLogo } from "@/components/icons/Logo.tsx";
import { Button } from "@/components/ui/button.tsx";

type ServiceUnavailableProps = {
  onRetry: () => void;
};

export function ServiceUnavailable({ onRetry }: ServiceUnavailableProps) {
  return (
    <div className="flex h-dvh items-center justify-center px-6">
      <div className="flex max-w-sm flex-col items-center gap-6 text-center">
        <OkthxLogo className="size-12" viewBox="-0.118 0.45 23.593 23.593" />
        <div className="space-y-2">
          <h1 className="text-xl font-semibold">Can&apos;t reach Okthx right now</h1>
          <p className="text-muted-foreground">Your session is safe.</p>
        </div>
        <div className="flex flex-col items-center gap-2">
          <Button data-statsig-name="service-unavailable-retry" variant="primary" onClick={onRetry}>
            Try again
          </Button>
        </div>
      </div>
    </div>
  );
}
